// extracted by mini-css-extract-plugin
export default {"gutter":"20px","link":"SegmentLinkItem-module_link__3rtiR","active":"SegmentLinkItem-module_active__3hnz9"};